import React from 'react';

class UsageReports extends React.Component {
    render() {
        return (
            <div className="rightSidePanel slide">
                <div className="pl-5 pr-5 reports">
                    <div className="row">
                        <div className="col-12 p-0">
                            <label className="searchDiv"><i className="fa fa-search" aria-hidden="true"> </i><span>|</span>
                                <input type="text" placeholder="Search keyword" />
                            </label>
                        </div>
                    </div>
                    <div className="row userTitle">
                        <div className="col-12">
                            <p className="m-0 userlistlabel">Reports</p>
                            <p className=" userlistSublabel">Choose from the list of reports</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 ">
                            <label className="reportDetails w-100">
                                <span className="reportName">Report 1</span>
                                <span className="viewBtn">View</span>
                            </label>
                        </div>
                        <div className="col-12 ">
                            <label className="reportDetails w-100">
                                <span className="reportName">Report 2</span>
                                <span className="viewBtn">View</span>
                            </label>
                        </div>
                        <div className="col-12 ">
                            <label className="reportDetails w-100">
                                <span className="reportName">Report 3</span>
                                <span className="viewBtn">View</span>
                            </label>
                        </div>
                        <div className="col-12 ">
                            <label className="reportDetails w-100">
                                <span className="reportName">Report 4</span>
                                <span className="viewBtn">View</span>
                            </label>
                        </div>
                        <div className="col-12 ">
                            <label className="reportDetails w-100">
                                <span className="reportName">Report 5</span>
                                <span className="viewBtn">View</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UsageReports